import { Controller } from "@hotwired/stimulus"

// Store cart (TMS-1247): submits a line's new quantity once the stepper settles, so the
// cart re-resolves packs and re-prices without a separate Update button.
export default class extends Controller {
  disconnect() {
    clearTimeout(this.timer)
  }

  changed() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.element.requestSubmit(), 500)
  }
}
